<template>
  <div :class="{ 'modal-window__wrap': modal }">
    <button
      v-if="modal"
      type="button"
      @click="$emit('close')"
      class="button button--close"
      aria-label="close modal"
    >
      <font-awesome-icon icon="times-circle" />
    </button>
    <form>
      <Legend class="modal-window__title">Timer Code</Legend>
      <p class="layout--flex-start layout--margin-bottom-sm">
        <font-awesome-icon
          icon="question-circle"
          class="text-color--blue text-size-md layout--margin-right-xs"
        />
        <a
          href="https://motionmail.freshdesk.com/support/solutions/articles/14000025916-will-motionmail-timers-work-with-my-email-marketing-platform-"
          target="_blank"
          class="link"
          >How to embed the code in your email</a
        >
      </p>
      <!-- free version of menu -->
      <fieldset
        class="modal-window__form-wrap modal-window__form-wrap--column"
        v-if="subscription.discriminator === 'Free'"
      >
        <strong>We offer extended options for paid plan users:</strong>
        <ul
          class="layout--plain-list layout--margin-top-md layout--margin-bottom-md"
        >
          <li>
            <font-awesome-icon
              icon="check"
              class="layout--margin-right-xs text-size-xs"
            />Choose from 1x, 2x, or 3x image resolution options
          </li>
          <li>
            <font-awesome-icon
              icon="check"
              class="layout--margin-right-xs text-size-xs"
            />Get a secure URL (https) for use on a page that uses SSL
          </li>
        </ul>
        <p class="layout--margin-bottom-none">
          <a
            href="/dashboard/change-plan/"
            class="link"
            @click.prevent="
              $emit('close');
              $router.push({ name: 'change plan' });
            "
            >Upgrade your plan</a
          >
          to enable these features.
        </p>
      </fieldset>
      <!-- paid version of menu -->
      <div
        class="modal-window__form-wrap"
        v-if="subscription.discriminator !== 'Free'"
      >
        <fieldset class="modal-window__form-section-wrap">
          <legend class="input-group__label">Resolution</legend>
          <v-radio-group v-model="selectedResolution" @change="unmarkCopied">
            <div
              v-for="option in resolutionOptions"
              :key="option.value"
              class="input-group__input-wrap input-group__input-wrap--radio"
            >
              <v-radio
                :value="option.value"
                :label="option.label"
                class="layout--margin-right-xs"
              />
            </div>
          </v-radio-group>
        </fieldset>
        <fieldset class="modal-window__form-section-wrap">
          <legend class="input-group__label">
            Secure URL<span class="weight--normal"> (https)</span>
          </legend>
          <div class="input-group__input-wrap">
            <v-checkbox
              v-model="ssl"
              class="layout--margin-right-xs"
              @change="unmarkCopied"
              label="For use on a page that uses SSL"
            />
          </div>
          <a
            href="https://motionmail.freshdesk.com/support/solutions/articles/14000082866-what-are-the-2x-and-3x-display-options-"
            target="_blank"
            class="link layout--margin-top-lg"
            >About these settings</a
          >
        </fieldset>
      </div>
      <input
        type="text"
        v-model="formattedCode"
        readonly
        class="modal-window__result-box layout--margin-top-md"
        aria-label="timer code"
      />
      <button
        type="button"
        v-if="!copied"
        class="button button--big button--wide layout--margin-top-md"
        @click="markCopied"
      >
        <IconCopy class="icon layout--margin-right-sm" />Copy code
      </button>
      <a
        href="https://motionmail.freshdesk.com/support/solutions/articles/14000025916-will-motionmail-timers-work-with-my-email-marketing-platform-"
        target="_blank"
        class="button button--secondary button--wide button--big layout--margin-top-md"
        v-if="copied"
      >
        <font-awesome-icon
          icon="check"
          class="text-color--green layout--margin-right-xs"
        /><strong class="layout--margin-right-xs">Copied!</strong>
        <span class="link">How to embed into your email</span
        ><span class="layout--screen-reader-only">opens in a new tab</span>
      </a>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import IconCopy from "../assets/icons/iconCopyCode.svg";

export default {
  name: "timer-code",
  props: { code: String, modal: Boolean },
  components: { IconCopy },
  data() {
    return {
      copied: false,
      selectedResolution: "",
      ssl: true,
      resolutionOptions: [
        { label: "Standard screens", value: "" },
        { label: "2x Retina screens", value: "scale_2x" },
        { label: "3x Super retina screens", value: "scale_3x" },
      ],
    };
  },
  computed: {
    ...mapGetters("account", ["subscription"]),
    formattedCode: function() {
      if (this.subscription.discriminator !== "Free") {
        let code = `<img src="${this.code}/${this.selectedResolution}" alt="motionmailapp.com" />`;
        if (this.ssl) {
          code = code.replace("http:", "https:");
        } else {
          code = code.replace("https:", "http:");
        }
        return code;
      }
      return `<img src="${this.code}" alt="motionmailapp.com" />`;
    },
  },
  methods: {
    markCopied: function() {
      this.$copyText(this.formattedCode).then(() => (this.copied = true));
    },
    unmarkCopied: function() {
      this.copied = false;
    },
  },
};
</script>

<style></style>
